export default __webpack_public_path__ + "static/media/pexels-pixabay-414928.c4e4140e.jpg";